var map = {
	"./add.svg": 122,
	"./ama2.png": 121,
	"./ama3.png": 120,
	"./avatar-caleb.png": 119,
	"./avatar-josh.png": 118,
	"./blockchain-news.jpg": 117,
	"./bloomberg.png": 116,
	"./cgtn.png": 115,
	"./cheddar.png": 114,
	"./cnbc-sept.jpg": 113,
	"./cnbc.png": 112,
	"./copy.svg": 64,
	"./cryptoslate.png": 111,
	"./cs-contact.svg": 62,
	"./cs.svg": 63,
	"./current-logo-white.png": 80,
	"./current-logo.png": 79,
	"./hero-image.png": 110,
	"./hero-image.svg": 109,
	"./hero-security.svg": 30,
	"./nbc-chicago.png": 108,
	"./tooltip.svg": 107,
	"./update18.png": 106,
	"./update19.png": 105,
	"./warning.svg": 104,
	"./yahoo-finance.png": 103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;